import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import PageIndex from "../../../PageIndex";
import { doPost } from "../../../../config/DataService";
import { Api } from "../../../../config/Api";

function ComingSoon() {
  const [referral, setReferral] = useState("");
  const [clipboardStatus, setClipboardStatus] = useState("");

  useEffect(() => {
    console.log("ComingSoon mounted, running effect");
    const params = new URLSearchParams(window.location.search);
    console.log("URL Parameters:", params.toString()); // Debugging log
    const referralCode = params.get("referral");
    console.log("Referral Code (from URL):", referralCode); // Debugging log

    if (referralCode) {
      setReferral(referralCode);
    } else if (navigator.clipboard && navigator.clipboard.readText) {
      // try to pull a value from the clipboard if no query param was found
      navigator.clipboard
        .readText()
        .then((text) => {
          console.log("clipboard.readText promise resolved");
          if (text) {
            console.log("Clipboard text:", text);
            // if the clipboard contains a full URL we can use it directly,
            // otherwise assume it is a referral code
            if (text.startsWith("http")) {
              // optionally parse query parameter from clipboard URL
              const clipParams = new URLSearchParams(
                new URL(text).search
              );
              const clipReferral = clipParams.get("referral");
              console.log("Clipboard Referral Code:", clipReferral);
              setReferral(clipReferral || text);
            } else {
              setReferral(text);
            }
          } else {
            console.log("clipboard text empty");
          }
        })
        .catch((err) => {
          console.error("Unable to read clipboard:", err);
        });
    } else {
      console.log("clipboard API not available or no referral code in URL");
    }
  }, []);

  // determine the URLs for the store buttons; if `referral` already
  // contains a full URL (such as something read from the clipboard) use it
  // directly, otherwise interpolate it into the default link format.
  const iosLink = referral.startsWith("http")
    ? referral
    : `https://apps.apple.com/us/app/plutope-crypto-wallet/id6466782831?referral=${referral}`;
  const androidLink = referral.startsWith("http")
    ? referral // could parse for android if desired, but fallback to same
    : `https://play.google.com/store/apps/details?id=com.app.plutope&referrer=referral%3D${referral}`;

  const handleIosClick = async (e) => {
    e.preventDefault();
    try {
      if (referral) {
        const formData = new URLSearchParams();
        formData.append("referralCode", referral);
        await doPost(Api.ADD_REFERRAL_CODE, formData);
      }
    } catch (err) {
      console.error("Failed to store referral code:", err);
    } finally {
      window.open(iosLink, "_blank", "noopener,noreferrer");
    }
  };

  const checkClipboard = () => {
    console.log("checkClipboard called");
    if (navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard
        .readText()
        .then((text) => {
          console.log("clipboard.readText returned", text);
          if (text) {
            let message = `clipboard contains: ${text}`;
            if (text.startsWith("http")) {
              const clipParams = new URLSearchParams(new URL(text).search);
              const clipReferral = clipParams.get("referral");
              if (clipReferral) {
                message = `referral in clipboard URL: ${clipReferral}`;
              }
            }
            setClipboardStatus(message);
            console.log(message);
          } else {
            setClipboardStatus("clipboard is empty");
            console.log("clipboard is empty");
          }
        })
        .catch((err) => {
          console.error("Unable to read clipboard:", err);
          setClipboardStatus("clipboard read failed");
        });
    } else {
      setClipboardStatus("clipboard API not supported");
      console.log("clipboard API not supported");
    }
  };

  useEffect(() => {
    // log whenever referral state changes so you can see it in console
    console.log("referral state updated:", referral);
  }, [referral]);

  return (
    <>
      <Index.Box className="comingsoon-wrape">
        <img
          src={Index.Png.logo}
          className="admin-sidebar-logo"
          alt="logo"
        />

        <Index.Box className="inner">
          <Index.Box className="globe"></Index.Box>
          <Index.Box className="globe-shadow"></Index.Box>

          <Index.Typography component="h2">
            Coming Soon
          </Index.Typography>

          <Index.Box className="button-wrape">
            <a
              href={iosLink}
              onClick={handleIosClick}
              style={{ cursor: "pointer" }}
            >
              <img src={PageIndex.Png.iosappstore} alt="" />
            </a>

            {/* Dynamic Referral Added Here */}
            <Index.Link to={androidLink}>
              <img src={PageIndex.Png.androidappstore} alt="" />
            </Index.Link>
          </Index.Box>

          {/* clipboard check UI */}
          <Index.Box style={{ marginTop: 20, textAlign: "center" }}>
            <Index.Button onClick={checkClipboard}>
              Check clipboard for referral
            </Index.Button>
            {clipboardStatus && (
              <Index.Typography variant="body2" style={{ marginTop: 8 }}>
                {clipboardStatus}
              </Index.Typography>
            )}
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
}

export default ComingSoon;
